import type {
    JSX,
} from "preact";

export type UseDropdownKeyboardOptions = {
    isOpen: boolean;
    totalOptions: number;
    selectedIndex: number;
    setSelectedIndex: (fn: (prev: number) => number) => void;
    onSelect: (index: number) => void;
    onClose: () => void;
    onSubmitWhenClosed?: () => void;
};

export const useDropdownKeyboard = (options: UseDropdownKeyboardOptions): {
    handleKeyDown: (event: JSX.TargetedKeyboardEvent<HTMLElement>) => void;
} => {
    const {
        isOpen,
        totalOptions,
        selectedIndex,
        setSelectedIndex,
        onSelect,
        onClose,
        onSubmitWhenClosed,
    } = options;

    const handleKeyDown = (
        event: JSX.TargetedKeyboardEvent<HTMLElement>,
    ): void => {
        if (!isOpen || totalOptions === 0) {
            if (event.key === "Enter" && onSubmitWhenClosed) {
                event.preventDefault();
                onSubmitWhenClosed();
            }
            return;
        }

        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                setSelectedIndex((prev) =>
                    Math.min(prev + 1, totalOptions - 1)
                );
                break;
            case "ArrowUp":
                event.preventDefault();
                setSelectedIndex((prev) => Math.max(prev - 1, 0));
                break;
            case "Enter":
            case "Tab":
                event.preventDefault();
                onSelect(selectedIndex);
                break;
            case "Escape":
                onClose();
                break;
        }
    };

    return {
        handleKeyDown,
    };
};
